<script setup>
import TitleTwo from '@/components/title-des/titleTwo.vue'

const industryData = [
  {
    id: '01',
    title: '研',
    title2: '精准的赛道选择',
    des: '产业发展，心中有数',
  },
  {
    id: '02',
    title: '判',
    title2: '科学的发展决策',
    des: '赛道选择，心中有底',
  },
  {
    id: '03',
    title: '招',
    title2: '实时的企业智推',
    des: '产业招商，心中有术',
  },
  {
    id: '04',
    title: '管',
    title2: '全程的招商管理',
    des: '产业招商，心中有术',
  },
  {
    id: '05',
    title: '服',
    title2: '高效的服务平台',
    des: '产业发展，服务生态',
  },
]
</script>

<template>
  <div class="industryPart w-full flex items-center justify-center">
    <div class="bg-left-right">
      <div class="flex w-full flex-col items-center justify-center">
        <div>
          <TitleTwo
            title="我们的优势"
            top="24px"
            bottom="20px"
            sub-title="基于AI大模型技术为支撑，打造“研•判•招•管•服•培” 全栈产业发展赋能体系"
          />
        </div>
        <div class="w-full flex flex-wrap justify-center items-center gap-6">
          <div v-for="industry in industryData" :key="industry.id">
            <div class="flex flex-col justify-center items-center">
              <div class="font-bold text-[36px] text-[#fff] text-center tit">
                {{ industry.title }}
              </div>
              <div class="font-bold text-[28px] text-[#333333] mt-3">
                {{ industry.title2 }}
              </div>
              <div class="text-[20px] text-[#666666] mt-1">
                {{ industry.des }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.industryPart {
  margin-top: 24px;
  .bg-left-right {
    width: 100vw;
    height: 748px;
    background: center / contain no-repeat
      url("https://static.idicc.cn/cdn/official/H5/home_youshi_bg.png");
    background-size: 100% 100%;
  }
  .tit {
    width: 120px;
    height: 120px;
    background: center / contain no-repeat
      url("https://static.idicc.cn/cdn/official/H5/home_youshi_bg2.png");
    background-size: 100% 100%;
    line-height: 120px;
  }
}
</style>
